import { render, staticRenderFns } from "./FreightAdd.vue?vue&type=template&id=f8cf3362&scoped=true"
import script from "./FreightAdd.vue?vue&type=script&lang=js"
export * from "./FreightAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cf3362",
  null
  
)

export default component.exports